module.exports = __webpack_public_path__ + "img/142.192129b6.jpg";